import { Linear, Sine, TimelineLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../../Application";
import * as Constants from "../../Data/Constants";
import { ObstacleType } from "../../Data/Obstacles";
import { ProjectileToken } from "../../Data/ProjectileToken";
import * as SFX from "../../Data/SoundEffectKeys";
import * as Topics from "../../Data/Topics";
import { AnimatedObstacle } from "../../GameObjects/Obstacles/AnimatedObstacle";
import { BoxCollider } from "../../Physics/BoxCollider";

export class Fuujin extends AnimatedObstacle {
    private static readonly SPEED: number = -100;
    private static readonly SPEED_REV: number = -(Constants.PARALLAX_SPEED + Fuujin.SPEED * 2);
    private static readonly Y_RANGE: PIXI.Point = new PIXI.Point(-350, 0);
    private static readonly LAUNCH_THRESHHOLD: number = 450;
    private static readonly PROJ_OFFSET: PIXI.Point = new PIXI.Point(0, 0);

    private _hasLaunched: boolean;
    private _isReversed: boolean;

    private _speedTween: TimelineLite | undefined;
    private _hoverTween: TweenMax;

    constructor() {
        super(
            new HLF.SpriteAnimation(
                "fuujin-", Constants.SPRITESHEET_OBSTACLE_PREFIX + "00", 11, 2,
                12, false,
            ),
            Fuujin.SPEED,
            new BoxCollider(),
        );
        this._hasLaunched = false;
        this._isReversed = false;

        this.position.y = HLF.Random.floatBetweenPoint(Fuujin.Y_RANGE);

        this._anim.holdFrame(AnimatedObstacle.ANIM_KEY, 0);

        this._hoverTween = TweenMax.to(this, 1.5, {
            y: this.position.y + 25,
            ease: Sine.easeInOut,
            repeat: -1,
            yoyo: true,
        });
    }

    public get isReversed(): boolean {
        return this._isReversed;
    }

    private get speed(): number {
        return this._speed;
    }

    private set speed(pValue: number) {
        this._speed = pValue;
    }

    public update(pDeltaTime: number): void {
        super.update(pDeltaTime);
        this._anim.update(pDeltaTime);

        if (this._hasLaunched === false && this.position.x < Fuujin.LAUNCH_THRESHHOLD) {
            this.launch();
        }
    }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        if (this._speedTween !== undefined) { this._speedTween.kill(); }
        if (this._hoverTween !== undefined) { this._hoverTween.kill(); }
        super.destroy(pOptions);
    }

    private launch(): void {
        this._hasLaunched = true;
        this._isReversed = true;

        this._speedTween = new TimelineLite();
        this._speedTween.to(this, 1.0, {
            speed: 100,
            ease: Linear.easeNone,
        });
        this._speedTween.call(() => {
            Application.instance.audio.play(SFX.FUUJIN_AIR, 1, false, HLF.AudioCategory.SFX);
            this._anim.play(AnimatedObstacle.ANIM_KEY);
        }, undefined, this, 1.5);
        this._speedTween.call(() => {
            PubSub.publishSync(Topics.SPAWN_PROJECTILE, new ProjectileToken(
                ObstacleType.FUUJIN_PROJECTILE,
                HLF.PointUtils.add(this.position, Fuujin.PROJ_OFFSET),
            ));
        }, undefined, this, 1.65);
        this._speedTween.to(this, 1.0, {
            speed: Fuujin.SPEED_REV,
            ease: Linear.easeNone,
        }, 2.5);
    }
}
